module.exports = __webpack_public_path__ + "media/images/android-chrome-192x192-79a25480a4dca1a3fa4e6843e4a193a4.png";